import { Pencil, Settings, Share2, Trash2 } from "lucide-react";
import { Dropdown } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";


const CatalogModelContentHeaderButton = ({ disableUpdate = false, disableDelete = false, catalogSchema="Default" }) => {
  const navigate = useNavigate();
  const { modelName } = useParams();

  const handleUpdateCatalogModel = () => {
    if (disableUpdate) return;
    else if (catalogSchema === "IFAC") {
      navigate(`/catalogmodel/${encodeURIComponent(modelName)}/update-IFAC`);
    } else {
      navigate(`/catalogmodel/${encodeURIComponent(modelName)}/update`);
    }
  };

  const handleDeleteCatalogModel = () => {
    if (disableDelete) return;
    navigate(`/catalogmodel/${encodeURIComponent(modelName)}/delete`);
  };

  const handleShareCatalogModel = () => {
    if (disableDelete) return;
    navigate(`/catalogmodel/${encodeURIComponent(modelName)}/share`);
  };

  return (
    <div className="content-header-actions d-flex justify-content-end">
      <button
          className={`btn create-run-button me-3`}
          style={{
            backgroundColor: 'rgb(71, 148, 218)',
            color: 'white',
            fontWeight: 'bold',
            height: '50px',
          }}
          onMouseDown={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)'}
          onMouseUp={(e) => e.currentTarget.style.color = 'white'}
          onClick={handleShareCatalogModel}
          disabled={disableDelete}
        >
          <Share2 size={16} className="me-2" style={{ marginTop: '-2px' }} />
          Share this Model
      </button>
      <Dropdown>
        <Dropdown.Toggle
          variant="primary"
          className={`px-4 py-3 actions-dropdown-toggle ${(disableUpdate && disableDelete) ? 'disabled' : ''}`}
          disabled={(disableUpdate && disableDelete)}
        >
          <Settings size={16} className="update-button-icon me-1 actions-dropdown-icon" />
          Actions
        </Dropdown.Toggle>

        <Dropdown.Menu className="actions-dropdown-menu">
          <Dropdown.Item
            onClick={handleUpdateCatalogModel}
            className="d-flex align-items-center dropdown-item-update"
            disabled={disableUpdate}
          >
            <Pencil size={16} className="me-2" />
            Update Model
          </Dropdown.Item>
          <hr className="dropdown-divider" />
          <Dropdown.Item
            onClick={handleDeleteCatalogModel}
            className="d-flex align-items-center dropdown-item-delete"
            disabled={disableDelete}
          >
            <Trash2 size={16} className="me-2" />
            Delete Model
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default CatalogModelContentHeaderButton;
